import React from 'react';
import Paragraph from '@/shared/Paragraph';
import { formatPrice } from '../PlanCards/utils';
import { getFormattedPrice } from '@/utils/price';
import Div from '@/shared/Div';
import Span from '@/shared/Span';
import Heading from '@/shared/Heading';
const TAX_INCL_TEXT = '(Incl. of all taxes)';

function Price({ value, type }: any) {
  const { price, mrp, MRPText = 'MRP', discPercent, sellingPrice } = value;
  function renderSellingPrice(sellingPrice: any) {
    return getFormattedPrice(sellingPrice);
  }

  function renderMRP(
    sellingPrice: any,
    mrp: any,
    MRPText: any,
    style: any,
    showTaxInclText = false,
  ) {
    return (
      <Div className="flex">
        {sellingPrice !== mrp && mrp > 0 ? (
          <Span className={style}>
            {MRPText}&nbsp;<Span className="line-through">{getFormattedPrice(mrp)}</Span>
          </Span>
        ) : null}
        {showTaxInclText ? (
          <Span className="text-cm-medium leading-normal	">&nbsp;{TAX_INCL_TEXT}</Span>
        ) : null}
      </Div>
    );
  }

  switch (type) {
    case 'addToCartWithHeader':
      return (
        <Div className="flex">
          <Span className="text-h-3 lg:text-hd-3 text-cti-on-primary mr-s3">
            {renderSellingPrice(sellingPrice)}
          </Span>
          {renderMRP(
            sellingPrice,
            mrp,
            MRPText,
            'text-body-sm lg:text-body-sm-desktop text-cti-on-tertiary p-0.5 align-bottom-[4px] !leading-none pt-2.5',
          )}
        </Div>
      );
    case 'addToCart':
      return (
        <>
          <Div className="text-h-1 lg:text-hd-1"> {renderSellingPrice(sellingPrice)}</Div>
          <Div className="text-body-xs lg:text-body-xs-desktop flex flex-col gap-s2 m-0.5">
            {discPercent || discPercent === 0 ? (
              <Div className="align-sup text-body-xs lg:text-body-xs-desktop text-cu-positive  !leading-3">
                {discPercent}% OFF
              </Div>
            ) : null}
            {renderMRP(
              sellingPrice,
              mrp,
              MRPText,
              'text-body-sm lg:text-body-sm-desktop text-cti-on-tertiary',
              true,
            )}
          </Div>
        </>
      );
    case 'trending':
      return (
        <>
          <Paragraph className={'text-h-2'}>{sellingPrice}</Paragraph>
          {price && price !== sellingPrice ? (
            <Paragraph className="text-body-base text-cm-medium">
              MRP <Span className="line-through">{price}</Span>{' '}
              <Span className="text-cu-positive">{discPercent}</Span>
            </Paragraph>
          ) : null}
        </>
      );
    default:
      return <Paragraph>{formatPrice(price)}</Paragraph>;
  }
}
export default Price;
